import React, { useState, useEffect } from "react";

function Timer({ cureentAttendence }) {
  const [elapsedTime, setElapsedTime] = useState("00:00");

  useEffect(() => {
    if (!cureentAttendence?.CheckInTime) {
      return;
    }

    const startTimeUTC = new Date(cureentAttendence.CheckInTime).getTime();
    let timerInterval;

    // Convert TotalBreakHours to milliseconds
    const totalBreakMilliseconds = cureentAttendence.TotalBreakHours
      ? convertBreakHoursToMs(cureentAttendence.TotalBreakHours)
      : 0;

    function convertBreakHoursToMs(breakHours) {
      const hours = Math.floor(breakHours);
      const minutes = (breakHours % 1) * 100; // Extract minutes from the decimal part
      return (hours * 60 * 60 * 1000) + (minutes * 60 * 1000); // Convert to milliseconds
    }

    function formatTimeElapsed(ms) {
      let seconds = Math.floor(ms / 1000) % 60;
      let minutes = Math.floor(ms / (1000 * 60)) % 60;
      let hours = Math.floor(ms / (1000 * 60 * 60));
      return `${hours}h ${minutes}m`;
    }

    // If CheckOutTime or BreakStartTime is present, stop the timer.
    if (cureentAttendence?.CheckOutTime || cureentAttendence?.BreakStartTime) {
      const endTimeUTC = new Date(
        cureentAttendence.CheckOutTime || cureentAttendence.BreakStartTime
      ).getTime();
      const totalElapsedTime = endTimeUTC - startTimeUTC - totalBreakMilliseconds;
      setElapsedTime(formatTimeElapsed(totalElapsedTime));
      return; // Stop execution of useEffect by returning early.
    }

    if (Date.now() >= startTimeUTC) {
      timerInterval = setInterval(() => {
        const currentTimeUTC = Date.now();
        let endTimeUTC = currentTimeUTC;

        // If CheckOutTime exists, calculate total time until checkout
        if (cureentAttendence?.CheckOutTime) {
          endTimeUTC = new Date(cureentAttendence.CheckOutTime).getTime();
          if (currentTimeUTC >= endTimeUTC) {
            const totalElapsedTime = endTimeUTC - startTimeUTC - totalBreakMilliseconds;
            setElapsedTime(formatTimeElapsed(totalElapsedTime));
            clearInterval(timerInterval);
            return;
          }
        }

        // Calculate elapsed time from CheckInTime to current time, minus break time
        const elapsedTime = endTimeUTC - startTimeUTC - totalBreakMilliseconds;
        setElapsedTime(formatTimeElapsed(elapsedTime));
      }, 1000); // Update every second
    }

    // Cleanup the interval when the component unmounts or dependencies change
    return () => {
      if (timerInterval) clearInterval(timerInterval);
    };
  }, [cureentAttendence]);

  return (
    <p className="text-5xl font-bold">
      {elapsedTime}
    </p>
  );
}

export default Timer;
